async function pushNotification(notificationBody: NotificationOptions) {
  if (!('serviceWorker' in navigator)) {
    return;
  }

  const swRegistration = await navigator.serviceWorker.register(
    '/service-worker.js',
    {
      scope: '../../public',
    }
  );

  requestNotificationPermission(() => {
    swRegistration.showNotification('Obraplay', notificationBody);
  });

  return swRegistration;
}

async function requestNotificationPermission(callback: () => void) {
  if (!('Notification' in window)) {
    return;
  }

  await Notification.requestPermission().then(result => {
    if (result === 'granted') {
      callback();
    }
  });
}

export { requestNotificationPermission, pushNotification };
